<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="真伪查询"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-card shadow="never" class="search-card">
        <template #desc>
          <van-field
              name="number"
              v-model="number"
              label="球杆编码"
              placeholder="请输入球杆编码"
              class="search-input"
          />
        </template>
      </van-card>

      <van-button class="search-btn" block @click="search">查询</van-button>
    </div>
    <!-- 核心修改：包裹Vant卡片，和搜索区卡片风格统一 -->
    <div class="result-container">
      <van-card shadow="never" class="result-card" v-if="htmlContent">
        <template #desc>
          <div class="content-item" v-html="htmlContent"></div>
        </template>
      </van-card>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import { checkPortal } from "@/api/sales";
import { Dialog } from "vant";

export default {
  data() {
    return {
      number: '',
      htmlContent: '',
      isCust: false // 补充缺失的变量定义
    }
  },
  created() {
    // this.selectProductByUser();
  },
  methods: {
    //顶部标题栏返回事件
    onClickLeft() {
      this.$router.push('/app_home');
    },

    showDialogMsg(message) {
      Dialog.alert({
        title: '查询结果',
        message: message,
        dangerouslyUseHTMLString: true,
        // PC端弹窗适配
        style: { width: '90%', maxWidth: '600px', fontSize: '20px' }
      });
    },
    // 真伪查询
    search() {
      if (!this.number) { // 优化判空逻辑
        this.showDialogMsg('请输入球杆编码');
        return;
      }
      //球杆编号
      const keyWord = this.number;
      //先清除之前的查询结果
      this.htmlContent ="";
      this.isCust = false;
      //查询真伪接口
      checkPortal(keyWord).then(res => {
        if (res.code === 200) {
          const data = res.data;
          const code = data.code;
          let msgStr = "";

          if (code === 5) {
            msgStr = `<p class="no-margin">此杆号查询次数较多，疑似克隆号，请联系经销商或者联系官方售后确认</p>
                                <p>官方售后咨询：<a href="tel:18603360681">18603360681</a></p>
                            `;
            this.htmlContent = msgStr;
          } else if (code === 0) {
            this.htmlContent = msgStr;
          } else if (code === 2) {
            msgStr = `<p>很遗憾，您所查询的杆号非璟点公司提供正品行货，没有售后保障。请联系官方售后电话或找附近经销商确认。</p>
                                <p>官方售后咨询：<a href="tel:18603360681">18603360681</a></p>
                            `;
            this.htmlContent = msgStr;
          } else if (code === 1) {
            let agent_name = "";
            if (data.agent_name && data.agent_name !== '') {
              agent_name = "，授权销售商为[" +'<span>'+ data.agent_name +'</span>'+ "]。";
            }
            msgStr = `
                                  <p>恭喜您！该编号[<span>${data.portal_number}</span>]商品为正品，请您放心使用。</p>
                                  <p>${data.portalSpecs?'该编号商品为['+'<span>'+data.portalSpecs+'</span>'+']':''}</p>
                                  <p>该编号商品出货日期为[<span>${data.create_time}</span>]${agent_name}</p>
                                  <p>该编号商品已查询[<span>${data.check_number}</span>]次</p>
                                  <p>上次查询时间[<span>${data.cx_time}</span>]</p>
                              `;
            this.htmlContent = msgStr;
          }
        } else {
          // 处理接口返回非200的情况
          Dialog.alert({
            title: '提示',
            message: res.returnMsg || '查询失败，请稍后重试',
            style: { width: '90%', maxWidth: '600px', fontSize: '20px' }
          });
        }
      }).catch(err => {
        // 补充接口异常捕获
        Dialog.alert({
          title: '错误',
          message: '查询失败，请检查网络或稍后重试',
          style: { width: '90%', maxWidth: '600px', fontSize: '20px' }
        });
      })
    }
  }
}
</script>

<style scoped lang="scss">
// 黑金主题色变量
$black: #000000;
$gold: #D4AF37;
$dark-gold: #B8860B;

// 导航栏样式
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
  // PC端导航栏箭头适配
  @media (min-width: 768px) {
    font-size: 30px !important;
  }
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
  // PC端返回文字适配
  @media (min-width: 768px) {
    font-size: 30px !important;
  }
}
.top-bar {
  background: linear-gradient(135deg, $gold 0%, $dark-gold 100%);
  // PC端导航栏整体适配
  @media (min-width: 768px) {
    height: 70px !important;
    ::v-deep .van-nav-bar__title {
      font-size: 30px !important;
      line-height: 70px !important;
    }
  }
}

// 整体容器（核心：PC端50%宽度居中）
.h5-container {
  @media (min-width: 768px) {
    width: 50%;
    margin: 0 auto;
    min-height: 110vh;
    box-sizing: border-box;
    background-color: #1a1a1a;
  }
}
.container-item {
  padding: 0 16px;
  // PC端容器适配
  @media (min-width: 768px) {
    padding: 0 20px;
    margin-bottom: 42px;
  }
}

// 搜索卡片样式
.search-card {
  margin: 16px 0;
  border-radius: 12px;
  height: 200px;
  background-image: url('~@/assets/img/h5/search_bj.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  // PC端搜索卡片适配
  @media (min-width: 768px) {
    margin: 20px auto;
    width: calc(100% - 40px);
    max-width: 600px;
    height: 300px; // 增高卡片，适配PC端比例
    border-radius: 15px;
  }
}

// 搜索输入框样式
.search-input {
  margin-top: 160px;
  border-radius: 10px;
  border-bottom: none;
  background: linear-gradient(135deg, $gold 0%, $dark-gold 100%);
  // PC端输入框适配
  @media (min-width: 768px) {
    margin-top: 220px; // 调整位置，适配增高后的卡片
    --van-field-font-size: 18px;
    height: 60px;
    line-height: 60px;
    border-radius: 12px;
    ::v-deep .van-field__label {
      font-size: 18px;
      width: 80px;
      color: $black !important;
      font-weight: 600;
      line-height: 60px;
    }
    ::v-deep .van-field__control {
      font-size: 18px;
      color: $black;
      padding-right: 10px;
      height: 60px;
    }
    ::v-deep .van-field__placeholder {
      font-size: 18px;
      color: rgba(0,0,0,0.7) !important;
    }
  }
}

// 查询按钮样式
.search-btn {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background: linear-gradient(135deg, $gold 0%, $dark-gold 100%);
  color: $black;
  font-size: 16px;
  font-weight: bold;
  border: none;
  margin-bottom: 16px;
  margin-top: 32px;
  // PC端按钮适配
  @media (min-width: 768px) {
    height: 80px;
    font-size: 36px;
    border-radius: 12px;
    margin: 0 auto 30px;
    width: calc(100% - 40px);
    max-width: 600px;
    margin-top: 40px;
    &:hover {
      background: $dark-gold;
      cursor: pointer;
    }
  }
}

// 通用样式
.no-margin {
  margin: 0;
}

// 结果卡片容器样式
.result-container {
  padding: 0 16px;
  margin-top: 20px;
  // PC端结果容器适配
  @media (min-width: 768px) {
    padding: 0 20px;
    margin-top: 30px;
  }
}
::v-deep .van-card__content{
  @media (min-width: 768px) {
    min-height: 0 !important;
  }
}
// 结果卡片样式，和搜索卡片风格统一
.result-card {
  border-radius: 12px;
  padding: 20px 16px;
  background-color: #fff;
  // PC端结果卡片适配
  @media (min-width: 768px) {
    padding: 30px 25px;
    margin: 0 auto;
    width: calc(100% - 40px);
    max-width: 600px;
    border-radius: 15px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  }
}

// 核心修改：文字居中、调大行间距
:deep(.content-item) {
  width: 100%;
  text-align: center; // 文字水平居中
  p {
    font-size: 14px;
    line-height: 2; // 行间距调大，数值越大行距越宽
    margin: 0 0 8px 0; // 段落底部间距，避免文字挤在一起
    span{
      color: $dark-gold;
      font-weight: bold;
    }
  }
  a {
    color: $dark-gold;
    text-decoration: underline;
    font-weight: 500;
  }

  // PC端结果文本适配
  @media (min-width: 768px) {
    p {
      font-size: 16px;
      line-height: 2.2;
      margin: 0 0 5px 0;
      span {
        font-size: 16px;
      }
    }
    a {
      font-size: 20px;
      &:hover {
        color: $gold;
      }
    }
  }
}

// 弹窗样式PC端适配
::v-deep .van-dialog__title {
  @media (min-width: 768px) {
    font-size: 24px !important;
    margin-bottom: 15px !important;
  }
}
::v-deep .van-dialog__message {
  @media (min-width: 768px) {
    font-size: 20px !important;
    line-height: 1.6 !important;
  }
}
::v-deep .van-dialog__confirm {
  @media (min-width: 768px) {
    font-size: 20px !important;
    padding: 0 30px !important;
  }
}
</style>